/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.container[_ngcontent-%COMP%]{background:#fff;text-align:center;height:100vh;font-family:sans-serif;font-weight:400}.container[_ngcontent-%COMP%]   .error-text[_ngcontent-%COMP%]{width:56em;margin:5rem auto 0}@media (max-width:768px){.container[_ngcontent-%COMP%]   .error-text[_ngcontent-%COMP%]{width:95%}}.container[_ngcontent-%COMP%]   .error-reference[_ngcontent-%COMP%]{color:#767676;font-size:.85em}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2Vycm9yL2Vycm9yLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2Vycm9yL2Vycm9yLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/error/error.component.scss.shim.ngstyle.ts